import { render, staticRenderFns } from "./MaterialProgrammatic.vue?vue&type=template&id=ffc916b0&scoped=true&"
import script from "./MaterialProgrammatic.vue?vue&type=script&lang=js&"
export * from "./MaterialProgrammatic.vue?vue&type=script&lang=js&"
import style0 from "./MaterialProgrammatic.vue?vue&type=style&index=0&id=ffc916b0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc916b0",
  null
  
)

export default component.exports